import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=6f60de5c&scoped=true"
import script from "./CheckList.vue?vue&type=script&lang=js"
export * from "./CheckList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60de5c",
  null
  
)

export default component.exports